/* eslint-disable no-nested-ternary */
/* eslint-disable import/extensions */

import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;
export const getServerPages = async () => {
  const Components = {};

  if (ssr) {
    Components.Home = (await import('./pages/Home.jsx')).Home;
    Components.BrowseError = (await import('./pages/BrowseError.jsx')).BrowseError;
    Components.ProductError = (await import('./pages/ProductError.jsx')).ProductError;
    Components.Generic = (await import('./pages/Generic.jsx')).Generic;
  }
  return Components;
};
export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import(
      './pages/Home'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.Home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/home',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  browse: {
    name: 'BrowseError',
    componentName: 'BrowseError',
    chunk: () => import(
      './pages/BrowseError'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.BrowseError
        : currentRouteName === 'BrowseError'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseError })));
    },
    path: '/:context?/b/*',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  search: {
    name: 'BrowseError',
    componentName: 'BrowseError',
    chunk: () => import(
      './pages/BrowseError'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.BrowseError
        : currentRouteName === 'BrowseError'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseError })));
    },
    path: '/:context?/s/*',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  product: {
    name: 'ProductError',
    componentName: 'ProductError',
    chunk: () => import(
      './pages/ProductError'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.ProductError
        : currentRouteName === 'ProductError'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductError })));
    },
    path: '/:context?/p/:slug?/:itemId',
    prefetch: [],
    channel: null,
    varnish: false,
  },
  generic: {
    name: 'Generic',
    componentName: 'Generic',
    chunk: () => import(
      './pages/Generic'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.Generic
        : currentRouteName === 'Generic'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Generic })));
    },
    path: '/:context?/*',
    prefetch: [],
    channel: null,
    varnish: false,
  },
});
